const DATA = {
	token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRlc3RAZ2FtaWwuY29tIiwidXNlcklkIjoiNjViNzYwOGJlMTAxMjQyMTI4NmE2ZmE4IiwiaWF0IjoxNzA3NTUwNjIyLCJlbghvbvxvbeHAiOjE3MDc1OTM4MjJ9.grVgIToYaNNJV6T5451T-uH455413K6f067c1CyNisHnJeZXJuEP0",
	uid: "65b7608be1012421286a6fa8",
	email: "test@gmail.com",
};

const PROFILE_VAR = "dashboard-user";

const login = async (email = "", password = "") => {
	try {
		const { data } = await handleLogin({ email, password });
		setUserProfile(data);
		return Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};

const handleLogin = ({ email, password }) => {
	try {
		return new Promise((resolve, reject) => {
			if (email === process.env.REACT_APP_USER_NAME && password === process.env.REACT_APP_USER_PASSWORD) {
				resolve({ data: { ...DATA, email } });
			} else if (email === process.env.REACT_APP_USER_NAME) {
				reject({ message: "Auth failed" });
			} else {
				reject({ message: "Auth failed" });
			}
		});
	} catch (error) {}
};

const setUserProfile = (user) => {
	localStorage.setItem(PROFILE_VAR, JSON.stringify(user));
};

const getUserProfile = () => {
	const userProfile = localStorage.getItem(PROFILE_VAR);
	if (userProfile) {
		return JSON.parse(userProfile);
	} else {
		localStorage.clear();
	}
};

const userLogout = () => {
	localStorage.clear();
	// window.location.reload();
};

export { setUserProfile, getUserProfile, login, userLogout };
